const Promise = require('bluebird')

module.exports = () => Promise.each([
    require('./customers_count'),
    require('./properties_count'),
    require('./buildings_count'),
    require('./properties_outdated_count'),
    require('./properties_without_photos_count'),
    require('./properties_outdated'),
    require('./properties_raised'),
    require('./individual_goals'),
    require('./menu_properties_count'),
    require('./menu_buildings_count'),
    require('./menu_customers_count'),
    require('./menu_events_count')
], (widget) => widget())



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/widgets/index.js